// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a_1Pyyv2A3xot7WWXqIX {
    display: flex;
    gap: 20px;
    height: 100%;
    padding: 20px;
    width: calc(100% - var(--width-sidebar));
    flex-direction: row;
    background-color: white;
    border-radius: 10px;
}
@media screen and (max-width: 1239px) {
    .a_1Pyyv2A3xot7WWXqIX {
        width: calc(100% - var(--width-tablet-sidebar));
    }
    }

.G5CVRGkId1Q7uzoejIHE {
    padding: 20px;
    width: 100%;
    display: flex;
    gap: 20px;
    height: 100%;
    flex-direction: row;
}

.fdNUPUpJ2FAvfFvNujd4 {
    width: 100%;
    height: calc(100vh - 20px);
    height: calc(100dvh - 20px);
    padding: 10px;
    border-radius: 10px;
    background-color: var(--white);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 20px;
    margin-top: 0;
}
.xfUffjw45qA6hDAtQA4N {
    flex: 3 0;
    display: flex;
    flex-direction: column;
    /* border-radius: 5px; */
    height: 100%;
    overflow: hidden;
    /* justify-content: space-between; */

    /* @media screen and (min-width: 1101px) {
        box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    } */
} 
@media screen and (max-width: 767px) {
    .xfUffjw45qA6hDAtQA4N {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        padding-bottom: 5px;
    }
}

.yAgGkluPYZYXeI1UsMni {
    width: 100%;
    display: flex;
    flex: 0 0;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    height: 60px;
    background-color: var(--white);
    border-radius: 5px;
    padding-bottom: 10px;
    justify-content: space-between;
}
@media screen and (max-width: 767px) {
    .yAgGkluPYZYXeI1UsMni {
        height: 30px;
        border-radius: 0;
        padding: 0;
        }
}
.mvyma4WkfwXioLdeUQYV {
    width: 100%;
    padding: 5px;
    padding-bottom: 8px;
    font-size: 11px;
    text-align: center;
    height: max-content;
    background-color: var(--white);
    border-radius: 5px;
    margin-bottom: 5px;
    /* margin-top: 15px; */
    /* box-shadow: 0px 4px 4px 0px #848C9C1A; */
}
.mvyma4WkfwXioLdeUQYV div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}
.mvyma4WkfwXioLdeUQYV p {
    padding-top: 5px;
    font-size: 10px;
}
@media screen and (max-width: 767px) {
    .mvyma4WkfwXioLdeUQYV {
        box-shadow: unset;
        margin: 0;
    }
}

.yCpO5GWcJvSHtwjMZ5i4 {
    overflow-y: scroll;
    height: 100%;
    padding: 5px 0;
    background-color: var(--white);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: relative;
    width: 100%;

    }
    @media screen and (max-width: 1239px) {
        .yCpO5GWcJvSHtwjMZ5i4 {
            height: calc(100% - 70px);
            border-radius: 5px;
        }
        .eW_i66QLtw1NahdhHAM_ {
            height: calc(100% - 160px);
        }
        .ReLIsWS3XPmvRaZ0hXjH {
            height: calc(100% - 180px);
        }
    }
    @media screen and (max-width: 767px) {
        .yCpO5GWcJvSHtwjMZ5i4, .eW_i66QLtw1NahdhHAM_, .ReLIsWS3XPmvRaZ0hXjH {
            flex: 1;
            height: auto;
            min-height: 0;
        }
    }
    .FdA3amg8_pEfWHZlFOQN {
        overflow-y: scroll;
        height: 100%;
        margin-top: 15px;
        padding: 5px 0;
        background-color: var(--white);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        position: relative;
        width: 100%;
        }
        @media screen and (max-width: 1239px) {
            .FdA3amg8_pEfWHZlFOQN {
                height: calc(100% - 45px);
                border-radius: 5px;
                box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            }
        }
        
canvas {
    margin: auto;
    width: 100%;
    border: 2px solid #F7F8FA;
    border-radius: 10px;
}

.Tcgtflvzsym9zYAECIEm {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-width: 255px;
    height: 100%;
}

.yFdC2JdmQN5i_YYaKxEK {
    font-size: 16px;
    display: flex;
    gap: 10px;
    text-align: center;
    justify-content: center;
    flex-direction: column; 
    height: 400px;
    width: 400px
}
@media screen and (max-width: 767px) {
    .yFdC2JdmQN5i_YYaKxEK {
        font-size: 14px;
    }
    .yFdC2JdmQN5i_YYaKxEK svg{
        font-size: 14px;
        height: 100px;
    }

}

`, "",{"version":3,"sources":["webpack://./src/styles/View/View.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,+CAA+C;IACnD;IACA;;AAEJ;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,SAAS;IACT,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;;IAEpC;;OAEG;AACP;AACA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,OAAO;QACP,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;AAClC;AACA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,UAAU;QACV;AACR;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI;QACI,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;;IAEX;IACA;QACI;YACI,yBAAyB;YACzB,kBAAkB;QACtB;QACA;YACI,0BAA0B;QAC9B;QACA;YACI,0BAA0B;QAC9B;IACJ;IACA;QACI;YACI,OAAO;YACP,YAAY;YACZ,aAAa;QACjB;IACJ;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,8BAA8B;QAC9B,8BAA8B;QAC9B,+BAA+B;QAC/B,kBAAkB;QAClB,WAAW;QACX;QACA;YACI;gBACI,yBAAyB;gBACzB,kBAAkB;gBAClB,wFAAwF;YAC5F;QACJ;;AAER;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,aAAa;IACjB;;AAEJ","sourcesContent":[".box {\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    padding: 20px;\n    width: calc(100% - var(--width-sidebar));\n    flex-direction: row;\n    background-color: white;\n    border-radius: 10px;\n}\n@media screen and (max-width: 1239px) {\n    .box {\n        width: calc(100% - var(--width-tablet-sidebar));\n    }\n    }\n\n.wrapperIte {\n    padding: 20px;\n    width: 100%;\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    flex-direction: row;\n}\n\n.boxmobile {\n    width: 100%;\n    height: calc(100vh - 20px);\n    height: calc(100dvh - 20px);\n    padding: 10px;\n    border-radius: 10px;\n    background-color: var(--white);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    margin: 20px;\n    margin-top: 0;\n}\n.left {\n    flex: 3 0;\n    display: flex;\n    flex-direction: column;\n    /* border-radius: 5px; */\n    height: 100%;\n    overflow: hidden;\n    /* justify-content: space-between; */\n\n    /* @media screen and (min-width: 1101px) {\n        box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    } */\n} \n@media screen and (max-width: 767px) {\n    .left {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        min-height: 0;\n        padding-bottom: 5px;\n    }\n}\n\n.toolsLine {\n    width: 100%;\n    display: flex;\n    flex: 0 0;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    height: 60px;\n    background-color: var(--white);\n    border-radius: 5px;\n    padding-bottom: 10px;\n    justify-content: space-between;\n}\n@media screen and (max-width: 767px) {\n    .toolsLine {\n        height: 30px;\n        border-radius: 0;\n        padding: 0;\n        }\n}\n.blockStatus {\n    width: 100%;\n    padding: 5px;\n    padding-bottom: 8px;\n    font-size: 11px;\n    text-align: center;\n    height: max-content;\n    background-color: var(--white);\n    border-radius: 5px;\n    margin-bottom: 5px;\n    /* margin-top: 15px; */\n    /* box-shadow: 0px 4px 4px 0px #848C9C1A; */\n}\n.blockStatus div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n.blockStatus p {\n    padding-top: 5px;\n    font-size: 10px;\n}\n@media screen and (max-width: 767px) {\n    .blockStatus {\n        box-shadow: unset;\n        margin: 0;\n    }\n}\n\n.pdf {\n    overflow-y: scroll;\n    height: 100%;\n    padding: 5px 0;\n    background-color: var(--white);\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    position: relative;\n    width: 100%;\n\n    }\n    @media screen and (max-width: 1239px) {\n        .pdf {\n            height: calc(100% - 70px);\n            border-radius: 5px;\n        }\n        .pdf_m {\n            height: calc(100% - 160px);\n        }\n        .pdf_s {\n            height: calc(100% - 180px);\n        }\n    }\n    @media screen and (max-width: 767px) {\n        .pdf, .pdf_m, .pdf_s {\n            flex: 1;\n            height: auto;\n            min-height: 0;\n        }\n    }\n    .pdfPub {\n        overflow-y: scroll;\n        height: 100%;\n        margin-top: 15px;\n        padding: 5px 0;\n        background-color: var(--white);\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n        position: relative;\n        width: 100%;\n        }\n        @media screen and (max-width: 1239px) {\n            .pdfPub {\n                height: calc(100% - 45px);\n                border-radius: 5px;\n                box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n            }\n        }\n        \ncanvas {\n    margin: auto;\n    width: 100%;\n    border: 2px solid #F7F8FA;\n    border-radius: 10px;\n}\n\n.right {\n    flex: 1 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 255px;\n    height: 100%;\n}\n\n.emptyDocsIcon {\n    font-size: 16px;\n    display: flex;\n    gap: 10px;\n    text-align: center;\n    justify-content: center;\n    flex-direction: column; \n    height: 400px;\n    width: 400px\n}\n@media screen and (max-width: 767px) {\n    .emptyDocsIcon {\n        font-size: 14px;\n    }\n    .emptyDocsIcon svg{\n        font-size: 14px;\n        height: 100px;\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `a_1Pyyv2A3xot7WWXqIX`,
	"wrapperIte": `G5CVRGkId1Q7uzoejIHE`,
	"boxmobile": `fdNUPUpJ2FAvfFvNujd4`,
	"left": `xfUffjw45qA6hDAtQA4N`,
	"toolsLine": `yAgGkluPYZYXeI1UsMni`,
	"blockStatus": `mvyma4WkfwXioLdeUQYV`,
	"pdf": `yCpO5GWcJvSHtwjMZ5i4`,
	"pdf_m": `eW_i66QLtw1NahdhHAM_`,
	"pdf_s": `ReLIsWS3XPmvRaZ0hXjH`,
	"pdfPub": `FdA3amg8_pEfWHZlFOQN`,
	"right": `Tcgtflvzsym9zYAECIEm`,
	"emptyDocsIcon": `yFdC2JdmQN5i_YYaKxEK`
};
export default ___CSS_LOADER_EXPORT___;
